import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subUnitSize: 'small',
    routerList: [],
    routerArr: [
      {
        path: '/home/index',
        title: '工作台'
      },

    ],
    imcustom: false,
    isunread: false,
    read: 0
  },
  mutations: {
    setRouter: (state, payload) => state.routerList = payload,
    setRouterArr(state, payload) {
      console.log(payload, 'payload')
      let o = state.routerArr.some(item => {
        return item.path == payload.path;
      })
      !o && state.routerArr.push(payload)
    }
  },
  actions: {
    setRouter({ commit }, router) {
      commit('setRouter', router)
    }
  },
  getters: {
    setRouter: state => state.routerList,
    routerArr: state => state.routerArr,
  },
  modules: {
  },
})
